import React, { useState } from "react";
import { useHistory } from "react-router";
import { useAppSelector } from "../../../context-store";
import CompanyDashboardModel from "../../../models/company/dashboard/response/CompanyDashboardModel";
import IdNameModel from "../../../models/common/IdNameModel";
import companyClasses from "../../../landing-pages/company/company.module.css";
import TablePagination from "@mui/material/TablePagination";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import RequirementSummaryGridComponent from "../../company/add-profiles/RequirementSummaryGridComponent";
import modalUtils from "../../../utils/modal-utils";
import { Button } from "@mui/material";

interface JobPostingDashboardGridProps {
    jobPostingList: CompanyDashboardModel[];
    status: IdNameModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
};

const JobPostingDashboardGridComponent = (props: JobPostingDashboardGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [roleId, setRoleId] = useState<number>(loggedInUser !== null ? parseInt(loggedInUser.roleId) : 0);
    const history = useHistory();

    const getStatusNameFromList = (statusId: number) => {
        let objStatus = props.status.find(x => x.id === statusId);
        if (objStatus !== null) {
            return objStatus?.name
        } else {
            return "";
        }
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const getRequirementSummary = (requirementId: string) => {
        const config: GeneralPoupConfig = {
            title: "Summary",
            content: (
                <RequirementSummaryGridComponent
                    requirementId={requirementId} />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    return (
        <div className="row">
            {props.jobPostingList.map((posting: CompanyDashboardModel) => {
                return (
                    <div className="col-lg-6 col-md-6 posting-listings">
                        <div className="card card-white">
                            <div className="card-heading clearfix ">
                                <h4 className="card-title title-job">{posting.jobCode}</h4>
                            </div>
                            <div className="card-body" >
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="row mb-2">
                                            <div className="col-lg-4 col-md-4">
                                                <b>Posted by:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value">
                                                {posting.postedBy}
                                            </div>
                                            <div className="col-lg-4 col-md-4">
                                                <b>Exp:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value">
                                                {posting.experience}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="row mb-2">
                                            <div className="col-lg-4 col-md-4">
                                                <b>Posted on:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value">
                                                {posting.postedDate}
                                            </div>
                                            <div className="col-lg-4 col-md-4">
                                                <b>Designation:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value des-highlight">
                                                {posting.designationName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="row mb-2">
                                            <div className="col-lg-2 col-md-2">
                                                <b>Skills:</b>
                                            </div>
                                            <div className="col-lg-10 col-md-10 job-posting-value">
                                                {posting.skills}
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <b>Status:</b>
                                            </div>
                                            <div className="col-lg-7 col-md-7">
                                                <a className={companyClasses.jobPostinglinks}>{getStatusNameFromList(posting.statusId)} <i className="fas fa-external-link-alt"></i></a>
                                            </div>
                                            <div className="col-lg-3 col-md-3">
                                                <Button variant="outlined" color="primary" size="small" onClick={() => getRequirementSummary(posting.requirementId)} startIcon={<i className="fas fa-check-circle"></i>}                                                >
                                                    Summary
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <TablePagination
                rowsPerPageOptions={props.pageSizesList}
                component="div"
                count={props.totalSize}
                rowsPerPage={props.pagesize}
                page={props.currentPage - 1}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
};
export default JobPostingDashboardGridComponent;